export default __webpack_public_path__ + "static/media/oscer-pres-nocturia.da36cfb5.svg";